<template>
  <div @click="closeModal" class="c-modal" :class="{active: is_active}">
    <span @click="closeModal" class="round_btn"></span>
    <video ref="video" @click="closeModal" controls width="700" height="700" src="@/assets/movie/how_to_play.mp4" />
  </div>
</template>
<script>
export default {
  name: "Modal",
  data() {
    return {
      isActive: false,
    }
  },
  props: {
    modal_content: {
      required: true,
    },
    is_active: {
      required: true,
      type: Boolean
    }
  },
  methods: {
    closeModal(e) {
      if (e.target.tagName === 'VIDEO') {
        return
      }
      this.$emit("test", false)
      this.$refs['video'].pause()
    },
  }
}
</script>
<style scoped>
.c-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: none;
  animation: hide 0.1s linear 0s;
  z-index: 1;
}

.c-modal.active {
  display: block;
  animation: show 0.1s linear 0s;
}

.round_btn {
  display: block;
  position: absolute;
  right: 130px;
  top: 50px;
  width: 70px;
  height: 70px;
  border: 2px solid #fff; /* 枠の調整 */
  border-radius: 50%;  /* 丸みの度合い */
  background: #fff; /* ボタンの背景色 */
  z-index: 9999;
}

.round_btn::before, .round_btn::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 6px; /* 棒の幅（太さ） */
  height: 22px; /* 棒の高さ */
  background: #ff0000; /* バツ印の色 */
}

.round_btn::before {
  transform: translate(-50%,-50%) rotate(45deg);
}

.round_btn::after {
  transform: translate(-50%,-50%) rotate(-45deg);
}

</style>



// WEBPACK FOOTER //
// src/components/Modal.vue